import { Action, combineReducers } from "redux";
import * as store from "../../../framework/customStore";
import { TDefaultListFilter } from "../../common/defaultListFilter";
import { ITaskPage } from "../../task";
import { TDefaultReportFilter } from "source/models/common/defaultReportFilter";

// State
export interface ITaskPageState {
    dataId: number;
    taskPage: ITaskPage;
}

export interface ITaskListState {
    defaultFilter: TDefaultListFilter;
}

export interface ITaskReportState {
    defaultFilter: TDefaultReportFilter;
}

export interface ITaskState {
    page: ITaskPageState;
    list: ITaskListState;
    report: ITaskReportState;
}

// Action type constants
const TASK_SUCCESS = "TASK_SUCCESS";
const TASK_FAILURE = "TASK_FAILURE";

const TASK_SUCCESS_LIST_SET_DEFAULT_FILTER = "TASK_SUCCESS_LIST_SET_DEFAULT_FILTER";
const TASK_SUCCESS_REPORT_SET_DEFAULT_FILTER = "TASK_SUCCESS_REPORT_SET_DEFAULT_FILTER";

type T_TASK_SUCCESS = typeof TASK_SUCCESS;
type T_TASK_FAILURE = typeof TASK_FAILURE;

type T_TASK_SUCCESS_LIST_SET_DEFAULT_FILTER = typeof TASK_SUCCESS_LIST_SET_DEFAULT_FILTER;
type T_TASK_SUCCESS_REPORT_SET_DEFAULT_FILTER = typeof TASK_SUCCESS_REPORT_SET_DEFAULT_FILTER;

// Action types
interface ITaskSuccess extends Action {
    type: T_TASK_SUCCESS;
    taskPage: ITaskPage;
}

interface ITaskFailure extends Action {
    type: T_TASK_FAILURE;
}

interface ITaskListSetDefaultFilter extends Action {
    type: T_TASK_SUCCESS_LIST_SET_DEFAULT_FILTER;
    defaultFilter: TDefaultListFilter;
}

interface ITaskReportSetDefaultFilter extends Action {
    type: T_TASK_SUCCESS_REPORT_SET_DEFAULT_FILTER;
    defaultFilter: TDefaultReportFilter;
}

export type TaskAction =
    | ITaskSuccess
    | ITaskFailure
    | ITaskListSetDefaultFilter
    | ITaskReportSetDefaultFilter;

//Actions
export const taskSuccess = (taskPage: ITaskPage): ITaskSuccess => ({
    type: TASK_SUCCESS,
    taskPage
});

export const taskFailure = (): ITaskFailure => ({
    type: TASK_FAILURE
});

export const taskListSetDefaultFilter = (defaultFilter: TDefaultListFilter): ITaskListSetDefaultFilter => ({
    type: TASK_SUCCESS_LIST_SET_DEFAULT_FILTER,
    defaultFilter
});

export const taskReportSetDefaultFilter = (defaultFilter: TDefaultReportFilter): ITaskReportSetDefaultFilter => ({
    type: TASK_SUCCESS_REPORT_SET_DEFAULT_FILTER,
    defaultFilter
});

//Reducers
export const taskInitialState: ITaskState = {
    page: {
        dataId: 0,
        taskPage: null
    },
    list: {
        defaultFilter: null
    },
    report: {
        defaultFilter: null
    }
};

const page = (state: ITaskPageState = null, action: TaskAction) => {
    switch (action.type) {
    case TASK_SUCCESS: {
        const taskSuccess = action as ITaskSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            taskPage: taskSuccess.taskPage
        };
    }
    case TASK_FAILURE:
        return { ...state };
    }
    return state;
};

const list = (state: ITaskListState = null, action: TaskAction) => {
    switch (action.type) {
    case TASK_SUCCESS_LIST_SET_DEFAULT_FILTER: {
        const listDefaultFilter = action as ITaskListSetDefaultFilter;
        return {
            ...state,
            defaultFilter: listDefaultFilter.defaultFilter
        };
    }
    }
    return state;
};

const report = (state: ITaskReportState = null, action: TaskAction) => {
    switch (action.type) {
    case TASK_SUCCESS_REPORT_SET_DEFAULT_FILTER: {
        const listDefaultFilter = action as ITaskReportSetDefaultFilter;
        return {
            ...state,
            defaultFilter: listDefaultFilter.defaultFilter
        };
    }
    }
    return state;
};

//Root reducer
export const taskReducer = combineReducers({
    page,
    list,
    report
});

//Utils
export const setTaskListDefaultFilter = (defaultFilter: TDefaultListFilter) => {
    store.customStore.dispatch(taskListSetDefaultFilter(defaultFilter));
};

export const setTaskReportDefaultFilter = (defaultFilter: TDefaultReportFilter) => {
    store.customStore.dispatch(taskReportSetDefaultFilter(defaultFilter));
};